import { Formik } from 'formik'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'

import { SubmitEmailWrapper, StyledForgotPasswordForm } from './styles'
import { ForgotPasswordFormValues, ForgotPasswordFormProps } from '../../types'
import { loginMessages } from '../../messages'

import CommonButton from 'components/Button/CommonButton'
import { EmailField } from 'components/Fields'
import { LoaderOverlay } from 'components/Loader'

export default function ForgotPasswordForm(props: ForgotPasswordFormProps) {
  const { handleSubmit } = props
  const history = useHistory()
  const { formatMessage } = useIntl()

  const initialValues: ForgotPasswordFormValues = {
    email: '',
  }

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {(formikProps) => (
        <StyledForgotPasswordForm>
          {formikProps.isSubmitting && <LoaderOverlay isFullScreen />}
          <EmailField
            name="email"
            autoComplete="email"
            invalid={formikProps.errors.email}
          />

          <SubmitEmailWrapper>
            <CommonButton type="button" onClick={() => history.push('/')}>
              {formatMessage(loginMessages.cancelButton)}
            </CommonButton>
            <CommonButton
              variant="primary"
              type="submit"
              disabled={
                formikProps.isSubmitting ||
                !formikProps.isValid ||
                !formikProps.values.email
              }
            >
              {formatMessage(loginMessages.sendEmailButton)}
            </CommonButton>
          </SubmitEmailWrapper>
        </StyledForgotPasswordForm>
      )}
    </Formik>
  )
}
